import { IPeriod } from "backend/model/model";
import * as m from "qpr-base/api/model";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { useQuery } from "react-query";

const usePeriods = (periodLevel?: string) => {
  const ctx = useAppContext();
  return useQuery<IPeriod[]>(
    `periods-${ctx.modelId}-${periodLevel || ""}`,
    async () => {
      return (await m.getPeriods(ctx.fullModelId || ""))
        .filter((p) => {
          if (periodLevel) {
            if (p.periodlevel === periodLevel) return true;
            return false;
          }
          return true;
        })
        .sort((a, b) => a.startdate.localeCompare(b.startdate));
    },
    {
      enabled: true,
      cacheTime: 30 * (60 * 1000),
      staleTime: 30 * (60 * 1000),
    }
  );
};

export default usePeriods;
